import { https } from "../http";
import store from "../store";
import { showError } from "../utils/index";
import { setLoading, setSubscriptionCard } from "../store/reducers/auth";
import { getProfile } from "./profile";
import swal from "sweetalert";

// POST
const selectPlan = async (data) => {
  try {
    //   store.dispatch(setAddStaffLoading(true));
    let response = await https().post("/subscription/create", data);

    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);

    return error?.response?.data?.message;
  }
};
const calTaxCustomPlan = async (data) => {
  try {
    //   store.dispatch(setAddStaffLoading(true));
    let response = await https().post("/subscription/cal-tax-custom-plan", data);

    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);

    return error?.response?.data?.message;
  }
};

const selectTrial = async (data) => {
  try {
    let response = await https().post("/subscription/create-trial", data);

    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);

    return error?.response?.data?.message;
  }
};
const downgradePlan = async (data) => {
  try {
    let response = await https().post("/payment/downgrade-plan", data);

    if (response?.status === 200) {
      getProfile();
      return true;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return error?.response?.data?.message;
  }
};

const upgradePlan = async (data) => {
  try {
    let response = await https().post("/payment/upgrade-plan", data);

    if (response?.status === 200) {
      getProfile();
      return true;
    }
  } catch (error) {
    console.log("🚀 ~ upgradePlan ~ error:", error);
    showError(error?.response?.data?.error);
    return error?.response?.data?.message;
  }
};

const upgradePlanAddOn = async (data) => {
  try {
    let response = await https().post(
      "/payment/subscription/update-plan-addon",
      data
    );

    if (response?.status === 200) {
      getProfile();
      swal({
        title: `Successful`,
        text: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      return response?.data;
    }
  } catch (error) {
    console.log("🚀 ~ upgradePlan ~ error:", error);
    showError(error?.response?.data?.message);
    return error?.response?.data?.message;
  }
};

// POST
const createSubscription = async (data, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/payment/paynow", data);

    if (response?.status === 200) {
      store.dispatch(setLoading(false));
      return response;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    return error?.response?.data?.message;
    // if (
    //   error?.response?.data?.message?.toLowerCase() ===
    //   "stripe customer not found"
    // )
    //   return navigate("/payInfo", {
    //     state: {
    //       planId: data?.packageId,
    //       stripePlan: data?.stripePlanId,
    //     },
    //   });
    // showError(error?.response?.data?.message, 500);
  }
};
const cancelSubscription = async (data) => {
  try {
    let response = await https().post("/payment/cancel-subscription", data);
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error;
  }
};
const cancelTrial = async (data) => {
  try {
    let response = await https().post("/payment/cancel-trial", data);
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error;
  }
};
// const cancelAiSubscription = async (data) => {
//   try {
//     let response = await https().post("/payment/ai-cancel-subscription", data);
//     if (response?.status === 200) {
//       return response;
//     }
//   } catch (error) {
//     showError(error?.response?.data?.message, 500);
//     return error;
//   }
// };

const forcePayment = async () => {
  try {
    let response = await https().post("/payment/force-payment");

    if (response?.status === 200) {
      getProfile();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, 500);
  }
};

const getSubscription = async (callback) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().get("/payment/getSubscription");
    if (response.status === 200)
      return response.data;
      //  callback(null, response?.data);
  } catch (error) {
    callback(error);
  }
};
const getUserSubscription = async (callback) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().get("/subscription");
    if (response.status === 200) callback(null, response?.data);
  } catch (error) {
    callback(error);
  }
};

const updateSubscriptionCustomer = async (data) => {
  try {
    let response = await https().put(
      "/payment/update-subscription-customer",
      data
    );
    if (response.status === 200) return response;
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error;
  }
};
const updateCardActive = async (data) => {
  try {
    let response = await https().put(
      "/payment/update-card-active",
      data
    );
    if (response.status === 200) return response;
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error;
  }
};

// setSubscriptionCard
const getSubscriptionCard = async (data) => {
  try {
    let response = await https().get(
      "/payment/getSubscriptionCard",
      data
    );
    if (response.status === 200)
      
       store.dispatch(setSubscriptionCard(response?.data));
       return response;
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error;
  }
};

const deleteCard = async (cardId, stripeCustomerId) => {
  try {
    let response = await https().delete("/payment/delete-card", {
      data: { cardId, stripeCustomerId },
    });
    if (response.status === 200) return response;
  } catch (error) {
    showError(error?.response?.data?.message, 500);
    return error?.response;
  }
};

export {
  getUserSubscription,
  createSubscription,
  selectPlan,
  selectTrial,
  downgradePlan,
  upgradePlan,
  getSubscription,
  forcePayment,
  cancelSubscription,
  cancelTrial,
  updateSubscriptionCustomer,
  upgradePlanAddOn,
  calTaxCustomPlan,
  getSubscriptionCard,
  updateCardActive,
  deleteCard,
  // cancelAiSubscription
};
